import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpHeaders,
  HttpXsrfTokenExtractor,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { SessionSotrageService } from "./session-sotrage.service";

@Injectable({
  providedIn: "root",
})
export class InterceptorService implements HttpInterceptor {
  messageValidator = 0;
  constructor(
    private sssotrage: SessionSotrageService,
    private xsrfExtractor: HttpXsrfTokenExtractor,
  ) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const token = this.xsrfExtractor.getToken() as string | null;
    const user = this.sssotrage.getCurrentSession(); // puede ser null

    var searchProfile = JSON.stringify(this.sssotrage.getPerfilBusqueda());
    searchProfile = searchProfile?.toString();

    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: user?.token ? `Bearer ${user.token}` : "",
      "X-XSRF-TOKEN": token ?? "",
      "X-Pf-Id": user?.sujetoObligadoId?.toString() ?? "-1",
      "X-Warehouse": user?.almacenId?.toString() ?? "-1",
      "X-profile": searchProfile?.toString() ?? "",
    });
    const reqClone = req.clone({ headers });
    if (token) {
      this.sssotrage.setCSRFToken(token);
    }
    return next.handle(reqClone);
  }
}
